import { Injectable } from '@angular/core';
import { type IndividualConfig } from 'ngx-toastr';

import { type ToastType } from '@common/utils/notify/notify.types';
import { BaseFacade } from '@common/services/base-facade.service';

import NotifyActions from '@common/utils/notify/notify.actions';

@Injectable()
export class NotifyFacade extends BaseFacade {
    public notifyAction(
        message: string,
        toastType: ToastType,
        title: string = '',
        config?: Partial<IndividualConfig>
    ): void {
        this.store$.dispatch(NotifyActions.showNotify({ toastType, message, title, config }));
    }
}
